export default __webpack_public_path__ + "static/media/refer-friend-img.9c068f00.svg";